import type { ReduxRootState } from 'types';

interface Params {
  messages: ReduxRootState['messages'];
}

const getAchievementAdminPermissionOptions = ({ messages }: Params) => ({
  'manage-users': messages.settingsPermissionManageUsers,
  'view-only': messages.achievementAdminPermissionsView
});

export default getAchievementAdminPermissionOptions;
